<template>
  <div>
    <el-select v-model="countryId" :disabled="disabled" placeholder="请选择国家" filterable :filter-method="getCountrys" @change="countryChange" style="width: 32%;margin-right:2%">
      <el-option label="请选择国家" value="0" key="0"></el-option>
      <el-option v-for="item in countrys" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select v-if="provinces && provinces.length>0" :disabled="disabled" v-model="provinceId" placeholder="请选择省" filterable :filter-method="getProvinces" @change="provinceChange" style="width: 32%;margin-right:2%">
      <el-option label="请选择省" value="0"></el-option>
      <el-option v-for="item in provinces" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select v-if="citys && citys.length>0" :disabled="disabled" v-model="cityId" placeholder="请选择市" filterable :filter-method="getCitys" @change="cityChange" style="width: 32%;">
      <el-option label="请选择市" value="0"></el-option>
      <el-option v-for="item in citys" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <!-- 
     -->
  </div>
</template>

<script>
import { GetFactoryInfos } from '@/api'
export default {
  data () {
    return {
      countrys: [],
      provinces: [],
      citys: [],
      query: {
        pageSize: 100,
        pageIndex: 1,
        keyWord: '',
        type: 0,
        parentId: ''
      },
      countryId: '',
      provinceId: '',
      cityId: '',
    }
  },
  props: {
    oldCountryId: {
      type: Number,
      default () {
        return 0
      }
    },
    oldProvinceId: {
      type: Number,
      default () {
        return 0
      }
    },
    oldCityId: {
      type: Number,
      default () {
        return 0
      }
    },
    disabled: {
      type: Boolean,
      default () {
        return true
      }
    }
  },

  watch: {
    'oldCountryId' (val, oldVal) {
      this.countryId = this.oldCountryId
      if (this.countryId == 0) {
        this.countryId = ''
      }
      else {
        this.getProvinces()
      }
    },
    'oldProvinceId' (val, oldVal) {
      this.provinceId = this.oldProvinceId
      if (this.provinceId == 0) {
        this.provinceId = ''
      }
      else {
        this.getCitys()
      }
    },
    'oldCityId' (val, oldVal) {
      this.cityId = this.oldCityId
      if (this.cityId == 0) {
        this.cityId = ''
      }
    },
  },
  created () {
    this.getData(this.query)
  },
  methods: {
    getCountrys (keyWord) {
      let query = { ...this.query }
      query.type = 0
      query.keyWord = keyWord
      query.parentId = ''

      this.getData(query)
    },
    getProvinces (keyWord) {
      let query = { ...this.query }
      query.type = 1
      query.keyWord = keyWord
      query.parentId = this.countryId

      this.getData(query)
    },
    getCitys (keyWord) {
      let query = { ...this.query }
      query.type = 2
      query.keyWord = keyWord
      query.parentId = this.provinceId

      this.getData(query)
    },
    getData (query) {
      GetFactoryInfos(query)
        .then(res => {
          if (query.type == 0) {
            this.countrys = res.returnData.data
          }
          else if (query.type == 1) {
            this.provinces = res.returnData.data
          }
          else if (query.type == 2) {
            this.citys = res.returnData.data
          }
        })
    },
    countryChange (val) {
      this.getProvinces('')
      this.provinceId = ''
      this.cityId = ''
      this.citys = []

      this.$emit('change', this.countryId, this.provinceId, this.cityId)
    },
    provinceChange (val) {
      this.getCitys('')
      this.cityId = ''

      this.$emit('change', this.countryId, this.provinceId, this.cityId)
    },
    cityChange (val) {
      this.$emit('change', this.countryId, this.provinceId, this.cityId)
    }
  }
}
</script>